import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "@common/style/bs-hw-ict.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./style/common.styl";
import { RequestService } from "@/zh-website/src/service";
import { ICT2B_CONFIG } from "@/zh-website/src/config";
import Message from "@common/ict/components/message";

//官网新引入
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
//font-awesome4->5 暂不引入
import "./uiAdapter";

Vue.config.productionTip = false;
// 设置
if (ICT2B_CONFIG.IS_PRO) {
  const meta = document.createElement("meta");
  meta.setAttribute("http-equiv", "Content-Security-Policy");
  meta.setAttribute("content", "upgrade-insecure-requests");
  document.getElementsByTagName("head")[0]?.appendChild(meta);
}

// 获取项目基础配置
const config = ICT2B_CONFIG;
const { BASE_URL } = config;
RequestService.defaults.baseURL = BASE_URL;
// 注册Vue原型属性
Vue.prototype.$BASE_API = BASE_URL;
Vue.prototype.$Message = Message;
router.afterEach(() => {
  window.scrollTo(0, 0);
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.needAuth)) {
    next();
  } else {
    next();
  }
});
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
// mount
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
